import { render, staticRenderFns } from "./UpdatePricingTierPopUp.vue?vue&type=template&id=2f9b6e4a&scoped=true&"
import script from "./UpdatePricingTierPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdatePricingTierPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePricingTierPopUp.vue?vue&type=style&index=0&id=2f9b6e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b6e4a",
  null
  
)

export default component.exports